module.exports = __webpack_public_path__ + "static/img/commissionTwo.7a0bfb9.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/commissionTwo.svg
// module id = HK7r
// module chunks = 4